<template>
	<el-row type="flex" :gutter="20" justify="center">
		<el-col :span="12">
			<div class="grid-content bg-purple">
				<div id="myChart_productView" style="width: auto;height:300px;"></div>
			</div>
		</el-col>
	</el-row>
	<el-row type="flex" :gutter="20" justify="center">
		<el-col :span="12">
			<div class="grid-content bg-purple">
				<div id="myChart_addCart" style="width: auto;height:300px;"></div>
			</div>
		</el-col>
	</el-row>
	<el-row type="flex" :gutter="20" justify="center">
		<el-col :span="12">
			<div class="grid-content bg-purple">
				<div id="myChart_productCollect" style="width: auto;height:300px;"></div>
			</div>
		</el-col>
	</el-row>
	<el-row type="flex" :gutter="20" justify="center">
		<el-col :span="12">
			<div class="grid-content bg-purple">
				<!-- <div id="myChart_productOrder" style="width: auto;height:300px;"></div> -->
			</div>
		</el-col>
	</el-row>
</template>

<script>
	import echarts from "echarts";
	export default {
		name: 'ProductViewRank',
		data() {
			return {
				item_productView: [],
				add_cart: [],
				product_collect: [],

				
			}
		},
		components: {
			echarts,
		},
		mounted() {
			this.getDataProductView();
			
			// this.myChart_productOrder();
		},
		methods: {
			getDataProductView() {
				this.httpPost({
					url: '/admin/analysis/productView',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.item_productView = temp.product_view;
					this.add_cart = temp.add_cart;
					this.product_collect = temp.product_collect;

					// console.log(this.item_productView)
					// console.log(this.add_cart)
					this.myChart_productView(); //执行下面的函数
					this.myChart_addCart(); //执行下面的函数
					this.myChart_productCollect();


				}).catch((err) => {})
			},
			myChart_productView() {
				// var i=0;
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_productView"));

				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '商品前十浏览排名',
						subtext: 'cosbravo',
						x: 'center',
					},
					legend:{
						right:'20%',
						data:['商品排名'] //对应的是name
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						itemSize: 15,
						itemGap : 15,
						feature: {
							magicType: {
								type: ['line', 'bar']
							},
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //触发方式
						formatter: '版号:{b}<br>浏览次数:{c}'
					},
					xAxis: {
						type: 'category',
						name: '排名',
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],  // x轴坐标名称
						axisLabel: {  //坐标轴刻度标签的相关设置。
                            formatter: '第{value}名'  //字符串模板
                        }
					},
					yAxis: {
						type: 'value',
						name: '商品浏览次数', //名称
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
					},
					grid:{
						top:80,
					},
					series: [{
						name: '商品排名',
						type: 'bar',
						data: this.item_productView,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],


				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			myChart_addCart(){
					// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_addCart"));
				
				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '商品购物车前十排名',
						subtext: 'cosbravo',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						itemSize: 15,
						itemGap : 15,
						feature: {
							magicType: {
								type: ['line', 'bar']
							},
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //出发方式
						formatter: '版号:{b}<br/>数量：{c}'
					},
					xAxis: {
						type: 'category',
						name: '排名',
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],  // x轴坐标名称
						axisLabel: {  //坐标轴刻度标签的相关设置。
                            formatter: '第{value}名'  //字符串模板
                        }
					},
					yAxis: {
						type: 'value',
						name: '商品购物车排名', //名称
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
					},
					grid:{
						top:80,
					},
					series: [{
						name: '商品购物车排名',
						type: 'bar',
						data: this.add_cart,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],
				
				
				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},
			myChart_productCollect(){
					// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_productCollect"));
				
				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '商品收藏排名',
						subtext: 'cosbravo',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						itemSize: 15,
						itemGap : 15,
						feature: {
							magicType: {
								type: ['line', 'bar']
							},
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //出发方式
						formatter: '版号:{b}<br/>数量：{c}'
					},
					xAxis: {
						type: 'category',
						name: '排名',
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],  // x轴坐标名称
						axisLabel: {  //坐标轴刻度标签的相关设置。
                            formatter: '第{value}名'  //字符串模板
                        }
					},
					yAxis: {
						type: 'value',
						name: '商品收藏排名', //名称
						nameTextStyle:{
							fontSize:12,
							color: '#333333',
							fontWeight: 'bold'
						 },
					},
					grid:{
						top:80,
					},
					series: [{
						name: '商品收藏排名',
						type: 'bar',
						data: this.product_collect,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],
				
				
				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			
			},
			myChart_productOrder(){
							// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_productOrder"));
				
				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '商品下单排名',
						subtext: 'cososen',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					// 提示框，鼠标移入
					// tooltip: {
					// 	show: true, //鼠标移入是否触发数据
					// 	trigger: 'item', //出发方式
					// 	formatter: '{b}<br/>订单数量：{c}'
					// },
					// visualMap: {
					// 	show: true,
					// 	min: this.visualMap.min,
					// 	max: this.visualMap.max,
					// 	right: 'right',
					// 	top: 'top',
					// 	text: ['高', '低'], // 文本，默认为数值文本
					// 	calculable: true,
					// 	seriesIndex: [0],
					// 	hoverLink: true,
					// 	inRange: {
					// 		color: ['#fb714c', '#70b4f4', '#70e4f4', '#f09640', '#f9d9bb'], //颜色
					// 		symbolSize: [60, 200],
					// 	}
					// },
					xAxis: {
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '商品下单排名',
						type: 'bar',
						data: [120, 200, 150, 80, 70, 110, 130],
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],
				
				
				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}
			
		}
	}
</script>

<style>
</style>
